import { trackAnonEvent } from '@/services/analytics/track-anon-event';

/** Fire a pre-auth login analytics event (see `trackAnonEvent` for semantics). */
export function trackLoginEvent(event: string, properties: Record<string, unknown> = {}): void {
  trackAnonEvent(event, properties);
}

export const LoginAnalyticsEvent = {
  SignInWithDifferentEmailClicked: 'User: Sign in With Different Email Clicked',
  SignInWithGoogleClicked: 'User: Sign in With Google Clicked',
  ChooseUserListViewed: 'User: Choose User List Viewed',
  LoggedIntoNewAccount: 'Multi-Account: User Logged Into New Account',
  InboxLinkClicked: 'User: Inbox Link Clicked',
  /** Same wire name Ember's set-password page fires, so both paths land in one series. */
  TeamMemberInviteAccepted: 'User: Team Member Invite Accepted',
} as const;
